import React from 'react';

interface FocusMaskProps {
  enabled: boolean;
  centerPercent: number;
  heightPercent: number;
  opacity: number;
}

export const FocusMask: React.FC<FocusMaskProps> = ({
  enabled,
  centerPercent,
  heightPercent,
  opacity,
}) => {
  if (!enabled || opacity <= 0) return null;

  const topPercent = Math.max(0, centerPercent - heightPercent / 2);
  const bottomPercent = Math.min(100, centerPercent + heightPercent / 2);

  return (
    <div className="absolute inset-0 pointer-events-none z-10" style={{ opacity }} aria-hidden="true">
      {/* Top dimming mask */}
      <div
        className="absolute left-0 right-0 top-0 focus-mask-top"
        style={{ height: `${topPercent}%` }}
      />
      {/* Bottom dimming mask */}
      <div
        className="absolute left-0 right-0 bottom-0 focus-mask-bottom"
        style={{ top: `${bottomPercent}%` }}
      />
    </div>
  );
};
